$( document ).ready(function() {
	var $titleTab = $('.title_tab');
	// $('.Accordion_item:eq(0)').find('.title_tab').addClass('active').next().stop().slideDown(300);
	// $('.Accordion_item:eq(0)').find('.inner_content').find('p').addClass('show');
	$titleTab.on('click', function(e) {
	e.preventDefault();
        $(this).parents('.Accordion_item').siblings().find('.title_tab').removeClass('active');
        $(this).parents('.Accordion_item').siblings().find('.inner_content').slideUp(500);
        $(this).parents('.Accordion_item').siblings().find('.inner_content').find('p').removeClass('show');
		if ( $(this).hasClass('active') ) {
            $(this).parent().removeClass('active');
			$(this).removeClass('active');
			$(this).next().stop().slideUp(500);
			$(this).next().find('p').removeClass('show');
		} else {
            $(this).parent().addClass('active');
			$(this).addClass('active');
			$(this).next().stop().slideDown(500);
			$(this).next().find('p').addClass('show');
		}
	});
});